'use client'

import { useEffect, useState } from 'react'

export const MSWComponent = ({ children }: { children: React.ReactNode }) => {
  const [mswReady, setMswReady] = useState(false)
  useEffect(() => {
    const init = async () => {
      const initMsw = await import('../mocks/index').then((res) => res.initMsw)
      await initMsw()
      setMswReady(true)
    }

    if (
      !mswReady &&
      ['local', 'dev'].includes(process.env.NEXT_PUBLIC_ENV as string) &&
      process.env.NEXT_PUBLIC_API_MOCKING === 'enabled'
    ) {
      init()
    }
  }, [mswReady])

  return <>{children}</>
}
